<div
  [ngClass]="{ '-show-modal ': isOpen() }"
  class="eva-3-modal -show-sticky-footer -smooth-scroll"
>
  <div class="modal-header">
    @if(!hideClose()) {
    <i
      class="eva-3-icon-cross modal-close false -eva-3-mr-md"
      role="button"
      tabindex="0"
      aria-label="Close modal"
      (click)="crossClicked()"
    ></i>
    }
    <div class="modal-title-container">
      <h4 class="modal-title">{{ title() }}</h4>
    </div>
  </div>
  <div class="modal-content">
    <ng-content select="[slot=content]"></ng-content>
  </div>
  <div class="modal-footer" [ngClass]="{ '-no-divider': !footerDivider() }">
    <div class="actions-container">
      <div class="left-sided">
        <ng-content select="[slot=secondaryActions]"></ng-content>
      </div>
      <div class="right-sided">
        <ng-content select="[slot=actions]"></ng-content>
      </div>
    </div>
  </div>
</div>
